/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoadersubtitle2Inputs */

const en_ailoadersubtitle2 = /** @type {(inputs: Ailoadersubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hang tight - this usually takes just a few seconds.`)
};

const de_ailoadersubtitle2 = /** @type {(inputs: Ailoadersubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte kurz warten – das dauert meist nur wenige Sekunden.`)
};

/**
* | output |
* | --- |
* | "Hang tight - this usually takes just a few seconds." |
*
* @param {Ailoadersubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoadersubtitle2 = /** @type {((inputs?: Ailoadersubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoadersubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoadersubtitle2(inputs)
	return de_ailoadersubtitle2(inputs)
});
export { ailoadersubtitle2 as "aiLoaderSubtitle" }